<template>
  <BaseDialog
    centered
    contentClass="confirmation"
    ref="dialog"
    persistent
    :show-actions="true"
    @closeModal="closeDialog"
    @dialog-closed="$emit('closed')"
  >
    <template slot="title">{{ $t('page.admin-invites.confirmation-dialog.title') }}</template>
    <template slot="content">
      <slot name="content"> </slot>
    </template>
    <template slot="actions">
      <div class="confirmation-dialog__actions">
        <BaseButton is-outlined class="confirmation-dialog__cancel" @click.native="cancelClick">{{
          cancelButtonText ? cancelButtonText : $t('actions.cancel')
        }}</BaseButton>
        <BaseButton :is-danger="isDanger" @click.native="execute">
          <span>{{ buttonText }}</span>
        </BaseButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseDialog from '@/components/base/BaseDialog';

export default {
  name: 'ConfirmationDialog',
  components: {
    BaseButton,
    BaseDialog,
  },
  props: {
    cancelButtonText: {
      type: String,
      required: false,
    },
    buttonText: {
      type: String,
      required: true,
    },
    isDanger: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    openDialog() {
      this.$refs.dialog.openModal();
    },
    execute() {
      this.$emit('execute');
      this.closeDialog();
    },
    cancelClick() {
      this.$emit('cancel-click');
      this.closeDialog();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
  },
};
</script>

<style lang="scss">
.base-dialog__confirmation {
  height: auto;
  width: 550px;
  position: relative;
  border-radius: $border-radius-root;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    min-height: max-content;
  }

  .base-dialog__actions {
    padding: 32px;
    background: transparent;
  }

  .close-icon__container {
    display: none;
  }
}

.confirmation-dialog {
  &__actions {
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    padding-right: 12px;
  }

  &__action {
    text-transform: lowercase;
    font-weight: bold;
  }

  &__user {
    color: $color-accent;
    font-weight: bold;
  }

  &__opportunity {
    font-weight: bold;
  }

  &__document {
    font-weight: bold;
  }

  &__annotation {
    margin-top: 8px;
    border-radius: $border-radius-small;

    .base-icon {
      width: 24px;
      height: 24px;
      padding-top: 10px;
    }

    &--text {
      padding: 0 4px;
      color: $color-normal;
      background: $color-text-annotation;
    }
  }
}
</style>
